import styled from 'styled-components';
import { COLOR, ie, mobile } from '../../../styles/variables';
import { Column, H4 } from '../../../styles/styledComponents';

export const StyledFooter = styled.footer`
    position: relative;
    background-color: ${COLOR.br24.veryDarkGrey};
    z-index: 9999;
    margin-top: -40px;
`;

export const ToTop = styled.div`
    width: 50px;
    height: 50px;
    border: 2px solid ${COLOR.contentBackground};
    background-color: ${COLOR.br24.veryDarkGrey};
    color: white;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    top: -25px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    transform: scale(1);
    will-change: transform;

    :hover {
        transform: scale(1.05);
    }
`;

export const TopLine = styled.div`
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    color: white;
    font-size: 2rem;

    a {
        color: ${COLOR.br24.mediumGrey};
    }

    > * {
        margin-right: 40px;
        color: ${COLOR.br24.mediumGrey};

        :hover {
            color: white;
        }
    }
`;

export const FooterColumnContent = styled.div`
    display: flex;
    flex-flow: column;

    @media ${mobile} {
        margin-top: 1rem;
    }
`;

// @ts-ignore
export const FooterColumn = styled(Column)`
    margin: 0 80px 34px 0;

    a {
        @media ${ie} {
            fill: inherit !important;
        }
    }

    ${H4} {
        color: ${COLOR.br24.mediumGrey};
        font-weight: 400;
        text-transform: uppercase;
        margin-bottom: 0.6rem;
    }

    @media ${mobile} {
        width: 95%;
        margin: 0 auto;
        align-items: center;
    }
`;

export const BottomLine = styled.div`
    background-color: black;
    display: flex;
    justify-content: flex-start;
    padding: 20px;
    align-items: center;
    height: 60px;

    @media ${mobile} {
        justify-content: center;
    }
`;

export const Content = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 1rem 0;

    a {
        text-decoration: none;
        line-height: 180%;

        :hover {
            text-decoration: underline;
        }
    }

    @media ${mobile} {
        flex-flow: column;
    }
`;

export const Logos = styled.div`
    height: 100%;
    display: flex;
    flex-flow: row;
    align-items: center;

    a {
        height: 100%;
        @media ${ie} {
            width: 100px;
        }
    }

    svg,
    g {
        height: 100%;
        fill: ${COLOR.br24.mediumGrey};
        width: auto;
        margin-right: 20px;
        :hover {
            fill: white;
        }
    }

    .ard {
        height: 130%;
    }

    @media ${mobile} {
        display: none;
    }
`;

export const Links = styled.div`
    color: white;
    margin-left: auto;

    @media ${mobile} {
        margin-left: unset;
    }
`;
